import React from 'react';
import { useParams } from 'react-router-dom';
import { formatContentResponsesRoute } from '../../../../../Survey/routes';
import SidebarNavItem from '../../SidebarNavItem/SidebarNavItem';

const ReviewResponsesNavItem = ({ content, navText }) => {
  const { projectId } = useParams();

  const reviewResponsesPath = formatContentResponsesRoute(projectId, content);

  return <SidebarNavItem path={reviewResponsesPath}>{navText}</SidebarNavItem>;
};

export default ReviewResponsesNavItem;
